import { GooglePayButtonColorEnumsObj } from "../enums/GooglePayButtonColorEnum";
import { GooglePayButtonSizeModeEnumsObj } from "../enums/GooglePayButtonSizeModeEnum";
import { GooglePayButtonTypeEnumsObj } from "../enums/GooglePayButtonTypeEnum";
import { isLocaleValid } from "@payair/e-com-common-sdk/core/Validators";
/**
 * Google Pay button paramaters type to control content and appearance of the button.
 */
var GooglePayButtonParams = /** @class */ (function () {
    function GooglePayButtonParams() {
    }
    return GooglePayButtonParams;
}());
export { GooglePayButtonParams };
/** @internal */
export var validateGooglePayButtonParams = function (googlePayButtonParams) {
    var errorMessage = [];
    if (!googlePayButtonParams)
        errorMessage.push("googlePayButtonParams not defined");
    else {
        if (!googlePayButtonParams.buttonColor)
            errorMessage.push("buttonColor not defined");
        else if (!Object.values(GooglePayButtonColorEnumsObj).includes(googlePayButtonParams.buttonColor)) {
            errorMessage.push("wrong buttonColor value");
        }
        if (googlePayButtonParams.buttonLocale && !isLocaleValid(googlePayButtonParams.buttonLocale)) {
            errorMessage.push("buttonLocale not valid");
        }
        if (googlePayButtonParams.buttonSizeMode !== undefined &&
            !Object.values(GooglePayButtonSizeModeEnumsObj).includes(googlePayButtonParams.buttonSizeMode))
            errorMessage.push("wrong buttonSizeMode value");
        if (!googlePayButtonParams.buttonType)
            errorMessage.push("buttonType not defined");
        else if (!Object.values(GooglePayButtonTypeEnumsObj).includes(googlePayButtonParams.buttonType))
            errorMessage.push("wrong buttonType value");
        if (googlePayButtonParams.buttonOnClick !== undefined && typeof googlePayButtonParams.buttonOnClick !== "function")
            errorMessage.push("buttonOnClick is not a function");
    }
    return errorMessage;
};
